import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          query ($jobId: String!) {\n            getUploadingJob (\n              jobId: $jobId\n            ) {\n              m_id\n              m_status\n            }\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          mutation {\n            createUploadingJob\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import Vue from 'vue';
import gql from 'graphql-tag';
import { Component } from 'vue-property-decorator';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';

var UploadingJob = /*#__PURE__*/function (_Vue) {
  _inherits(UploadingJob, _Vue);

  var _super = _createSuper(UploadingJob);

  function UploadingJob() {
    var _this;

    _classCallCheck(this, UploadingJob);

    _this = _super.apply(this, arguments);
    _this.showLoading = false;
    return _this;
  }

  _createClass(UploadingJob, [{
    key: "createUploadingJob",
    value: function () {
      var _createUploadingJob = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, jobId, now;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: gql(_templateObject())
                });

              case 3:
                result = _context.sent;
                jobId = result.data.createUploadingJob;
                now = this.$moment().unix();
                localStorage.setItem(process.env.VUE_APP_UPLOADING_JOB_ID, jobId + '@' + now);
                return _context.abrupt("return", jobId);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                showErrors(_context.t0.graphQLErrors);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function createUploadingJob() {
        return _createUploadingJob.apply(this, arguments);
      }

      return createUploadingJob;
    }()
  }, {
    key: "checkIfJobRunnig",
    value: function checkIfJobRunnig() {
      var _this2 = this;

      var jobRunning = localStorage.getItem(process.env.VUE_APP_UPLOADING_JOB_ID);

      if (!jobRunning) {
        return;
      }

      var arr = jobRunning.split('@');
      var now = this.$moment();
      var startTime = this.$moment.unix(arr[1]);

      if (startTime.add(5, 'm').isBefore(now)) {
        this.clearLoadingJob();
        return;
      }

      this.showLoading = true;
      this.intervalTimer = setInterval(function () {
        _this2.getRunningJob(arr[0]);
      }, 10000);
    }
  }, {
    key: "clearIntervalTimer",
    value: function clearIntervalTimer() {
      clearInterval(this.intervalTimer);
    }
  }, {
    key: "clearLoadingJob",
    value: function clearLoadingJob() {
      this.showLoading = false;
      localStorage.removeItem(process.env.VUE_APP_UPLOADING_JOB_ID);
    }
  }, {
    key: "getRunningJob",
    value: function () {
      var _getRunningJob = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(jobId) {
        var res, _res$data$getUploadin, m_status, m_errorMessage;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: gql(_templateObject2()),
                  variables: {
                    jobId: jobId
                  }
                });

              case 3:
                res = _context2.sent;
                _res$data$getUploadin = res.data.getUploadingJob, m_status = _res$data$getUploadin.m_status, m_errorMessage = _res$data$getUploadin.m_errorMessage;
                _context2.t0 = m_status;
                _context2.next = _context2.t0 === 'CREATE' ? 8 : _context2.t0 === 'UPLOADING' ? 9 : _context2.t0 === 'SUCCESS' ? 10 : _context2.t0 === 'FAIL' ? 12 : 14;
                break;

              case 8:
                return _context2.abrupt("return");

              case 9:
                return _context2.abrupt("return");

              case 10:
                showNotification({
                  msg: '导入成功',
                  type: SnackType.Info
                });
                return _context2.abrupt("break", 14);

              case 12:
                showErrors([{
                  message: {
                    message: m_errorMessage
                  }
                }]);
                return _context2.abrupt("break", 14);

              case 14:
                this.clearLoadingJob();
                this.clearIntervalTimer();
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2["catch"](0);
                this.clearLoadingJob();
                this.clearIntervalTimer();
                showErrors(_context2.t1.graphQLErrors);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 18]]);
      }));

      function getRunningJob(_x) {
        return _getRunningJob.apply(this, arguments);
      }

      return getRunningJob;
    }()
  }]);

  return UploadingJob;
}(Vue);

UploadingJob = __decorate([Component], UploadingJob);
export default UploadingJob;